import { myLabs } from "../../constants/actionTypes";

const myLabsListRequest = (data) => ({
  type: myLabs.MY_LABS_LIST_REQUEST,
  payload: data,
});

const myLabsListSuccess = (data) => ({
  type: myLabs.MY_LABS_LIST_SUCCESS,
  data: data,
});

const myLabsListError = (data) => ({
  type: myLabs.MY_LABS_LIST_ERROR,
  data: data,
});

const clearMylabsList = () => ({
  type: myLabs.CLEAR_MY_LABS_LIST,
});

const startMyLabRequest = (urlParams, bodyData, operation, lab) => ({
  type: myLabs.MY_LAB_VM_OPERATION,
  urlParams: urlParams,
  bodyData: bodyData,
  operation: operation,
  lab: lab,
});

const startMyLabSuccess = (data) => ({
  type: myLabs.START_MY_LAB_SUCCESS,
  data: data,
});

const stopMyLabSuccess = (data) => ({
  type: myLabs.STOP_MY_LAB_SUCCESS,
  data: data,
});

const suspendLabSuccess = (data) => ({
  type: myLabs.SUSPEND_MY_LAB_SUCCESS,
  data: data,
});

const resetLabSuccess = (data) => ({
  type: myLabs.RESET_MY_LAB_SUCCESS,
  data: data,
});

const shutdownGuestSuccess = (data) => ({
  type: myLabs.SHUTDOWN_MY_LAB_SUCCESS,
  data: data,
});

const restartGuestSucess = (data) => ({
  type: myLabs.RESTART_MY_LAB_SUCCESS,
  data: data,
});

const deleteMyLabSuccess = (data) => ({
  type: myLabs.DELETE_MY_LAB_SUCCESS,
  data: data,
});

const forceDeleteMyLabSuccess = (data) => ({
  type: myLabs.FORCE_DELETE_MY_LAB_SUCCESS,
  data: data,
});

const myLabsLoaderRequest = (data) => ({
  type: myLabs.LOADER_GET_REQUEST,
  data: data,
});

const myLabsLoaderSuccess = (data) => ({
  type: myLabs.LOADER_GET_SUCCESS,
  data: data,
});

const requestUpdateRate = (data, id) => ({
  type: myLabs.REQUEST_UPDATE_RATE,
  payload: data,
  id: id,
});

const successUpdateRate = (data) => ({
  type: myLabs.SUCCESS_UPDATE_RATE,
  payload: data,
});

const errorUpdateRate = (data) => ({
  type: myLabs.ERROR_UPDATE_RATE,
  payload: data,
});

const myLabsConnectRequest = (data) => ({
  type: myLabs.CONNECT_GET_REQUEST,
  data: data,
});

const myLabsConnectSuccess = (data) => ({
  type: myLabs.CONNECT_GET_SUCCESS,
  data: data,
});

const myLabsConnectError = (data) => ({
  type: myLabs.CONNECT_GET_ERROR,
  payload: data,
});

const extensionValidityGetRequest = (data) => ({
  type: myLabs.EXTENSION_VALIDITY_GET_REQUEST,
  payload: data,
});

const extensionValidityGetSuccess = (data) => ({
  type: myLabs.EXTENSION_VALIDITY_GET_SUCCESS,
  data: data,
});

const extensionValidityGetError = (data) => ({
  type: myLabs.EXTENSION_VALIDITY_GET_ERROR,
  data: data,
});

const extsnVldtyUpdateRequest = (data) => ({
  type: myLabs.EXTENSION_VALIDITY_UPDATE_REQUEST,
  data: data,
});

const extsnVldtyUpdateRequestWorkspace = (data) => ({
  type: myLabs.EXTENSION_VALIDITY_UPDATE_REQUEST_WORKSPACE,
  data: data,
});

const extsnVldtyCreateRequestWorkspace = (data) => ({
  type: myLabs.EXTENSION_VALIDITY_CREATE_REQUEST_WORKSPACE,
  data: data,
});

const extsnVldtyCreateRequest = (data) => ({
  type: myLabs.EXTENSION_VALIDITY_CREATE_REQUEST,
  data: data,
});

const extsnVldtyUpdateSuccess = (data) => ({
  type: myLabs.EXTENSION_VALIDITY_UPDATE_SUCCESS,
  data: data,
});

const extsnVldtyUpdateError = (data) => ({
  type: myLabs.EXTENSION_VALIDITY_UPDATE_ERROR,
  data: data,
});

const setWebsocketDataList = (data) => ({
  type: myLabs.SET_WEB_SOCKET_DATA,
  data: data,
});

const myLabVMAuthConnectDetails = (data) => ({
  type: myLabs.VM_AUTH_CONNECT_DETAILS,
  data: data,
});

const myLabVMAuthConnectDetailsSuccess = (data) => ({
  type: myLabs.VM_AUTH_CONNECT_SUCCESS,
  data: data,
});

const myLabVMAuthConnectDetailsError = (data) => ({
  type: myLabs.VM_AUTH_CONNECT_ERROR,
  data: data,
});

const requestVmDetails = (data) => ({
  type: myLabs.REQUEST_VM_DETAILS,
  payload: data,
});

const successVmDetails = (data) => ({
  type: myLabs.SUCCESS_VM_DETAILS,
  payload: data,
});

const errorVmDetails = (data) => ({
  type: myLabs.ERROR_VM_DETAILS,
  payload: data,
});

const removeSelectedVmDetails = () => ({
  type: myLabs.REMOVE_SELECTED_VM_DETAILS,
});

const getPooledVMTimer = (data) => ({
  type: myLabs.GET_POOLED_VM_TIMER,
  payload: data,
});

const getPooledVMTimerSuccess = (data) => ({
  type: myLabs.POOLED_VM_TIMER_SUCCESS,
  payload: data,
});

const getPooledVMTimerError = (data) => ({
  type: myLabs.POOLED_VM_TIMER_ERROR,
  payload: data,
});

const addVmDuration = (data) => ({
  type: myLabs.ADD_VM_DURATION,
  payload: data,
});

const addVmDurationApiResponse = (data) => ({
  type: myLabs.ADD_VM_DURATION_API_RESPONSE,
  payload: data,
});

const setAddVmDurationLoader = (data) => ({
  type: myLabs.ADD_VM_DURATION_LOADER,
  payload: data,
});

const getLabInstructionsAction = (data) => ({
  type: myLabs.GET_LAB_INSTRUCTIONS,
  payload: data,
});

const setLabInstructionsAction = (data) => ({
  type: myLabs.SET_LAB_INSTRUCTIONS,
  payload: data,
});

const getInstanceSizeList = (data) => ({
  type: myLabs.GET_INSTANCE_SIZE_LIST,
  payload: data,
});

const setInstanceSizeList = (data) => ({
  type: myLabs.SET_INSTANCE_SIZE_LIST,
  payload: data,
});

const setInstanceSizeListLoader = (data) => ({
  type: myLabs.INSTANCE_SIZE_LIST_LOADER,
  payload: data,
});

const setReconfigureVmLoader = (data) => ({
  type: myLabs.RE_CONFIGURE_VM_LOADER,
  payload: data,
});

const reconfigureVm = (data) => ({
  type: myLabs.RE_CONFIGURE_VM,
  payload: data,
});

const setReconfigureVmSuccess = (data) => ({
  type: myLabs.RE_CONFIGURE_VM_SUCCESS,
  payload: data,
});

const setReconfigureVmError = (data) => ({
  type: myLabs.RE_CONFIGURE_VM_ERROR,
  payload: data,
});

const reprovisionLabAction = (payload) => ({
  type: myLabs.RE_PROVISION_LAB_ACTION,
  payload: payload,
});
const reprovisionLabSuccess = (payload) => ({
  type: myLabs.RE_PROVISION_LAB_SUCCESS,
  payload: payload,
});
const reprovisionLabError = (payload) => ({
  type: myLabs.RE_PROVISION_LAB_ERROR,
  payload: payload,
});
const reprovisionLabReset = () => ({
  type: myLabs.RE_PROVISION_LAB_RESET,
});

// VM State Management
const vmStateManagementLoading = (payload) => ({
  type: myLabs.VM_STATE_MANAGEMENT_LOADING,
  payload: payload,
});

const vmStateManagementAction = (payload) => ({
  type: myLabs.VM_STATE_MANAGEMENT_ACTION,
  payload: payload,
});

const vmStateManagementSuccess = (payload) => ({
  type: myLabs.VM_STATE_MANAGEMENT_SUCCESS,
  payload: payload,
});

const vmStateManagementError = (payload) => ({
  type: myLabs.VM_STATE_MANAGEMENT_ERROR,
  payload: payload,
});

const vmStateManagementReset = () => ({
  type: myLabs.VM_STATE_MANAGEMENT_RESET,
});

const manageVMExportLoading = (payload) => ({
  type: myLabs.MANAGE_VM_DOWNLOAD_LOADING,
  payload: payload
});

const manageVMExportAction = (payload) => ({
  type: myLabs.MANAGE_VM_DOWNLOAD_ACTION,
  payload: payload
});

const manageVMExportSuccess = (payload) => ({
  type: myLabs.MANAGE_VM_DOWNLOAD_SUCCESS,
  payload: payload
});

const manageVMExportError = (payload) => ({
  type: myLabs.MANAGE_VM_DOWNLOAD_ERROR,
  payload: payload
});

const manageVMExportReset = () => ({
  type: myLabs.MANAGE_VM_DOWNLOAD_RESET
})

const restoreVmLoading = (payload) => ({
  type: myLabs.RESTORE_VM_LOADING,
  payload: payload
});
const restoreVmAction = (payload) => ({
  type: myLabs.RESTORE_VM_ACTION,
  payload: payload
});

const restoreVmSuccess = (payload) => ({
  type: myLabs.RESTORE_VM_SUCCESS,
  payload: payload
});

const restoreVmError = (payload) => ({
  type: myLabs.RESTORE_VM_ERROR,
  payload: payload
});

const restoreVmReset = () => ({
  type: myLabs.RESTORE_VM_RESET
})

export {
  myLabsListRequest,
  myLabsListSuccess,
  myLabsListError,
  startMyLabRequest,
  startMyLabSuccess,
  stopMyLabSuccess,
  suspendLabSuccess,
  resetLabSuccess,
  shutdownGuestSuccess,
  restartGuestSucess,
  deleteMyLabSuccess,
  forceDeleteMyLabSuccess,
  myLabsLoaderRequest,
  myLabsLoaderSuccess,
  requestUpdateRate,
  successUpdateRate,
  errorUpdateRate,
  myLabsConnectRequest,
  myLabsConnectSuccess,
  myLabsConnectError,
  extensionValidityGetRequest,
  extensionValidityGetSuccess,
  extensionValidityGetError,
  extsnVldtyUpdateRequest,
  extsnVldtyUpdateSuccess,
  extsnVldtyUpdateError,
  setWebsocketDataList,
  myLabVMAuthConnectDetails,
  myLabVMAuthConnectDetailsSuccess,
  myLabVMAuthConnectDetailsError,
  requestVmDetails,
  successVmDetails,
  errorVmDetails,
  removeSelectedVmDetails,
  extsnVldtyCreateRequest,
  extsnVldtyUpdateRequestWorkspace,
  extsnVldtyCreateRequestWorkspace,
  getPooledVMTimer,
  getPooledVMTimerSuccess,
  getPooledVMTimerError,
  addVmDuration,
  addVmDurationApiResponse,
  setAddVmDurationLoader,
  getLabInstructionsAction,
  setLabInstructionsAction,
  clearMylabsList,
  getInstanceSizeList,
  setInstanceSizeList,
  setInstanceSizeListLoader,
  setReconfigureVmLoader,
  reconfigureVm,
  setReconfigureVmSuccess,
  setReconfigureVmError,
  reprovisionLabAction,
  reprovisionLabSuccess,
  reprovisionLabError,
  reprovisionLabReset,
  vmStateManagementLoading,
  vmStateManagementAction,
  vmStateManagementSuccess,
  vmStateManagementError,
  vmStateManagementReset,
  manageVMExportLoading,
  manageVMExportAction,
  manageVMExportSuccess,
  manageVMExportError,
  manageVMExportReset,
  restoreVmLoading,
  restoreVmAction,
  restoreVmSuccess,
  restoreVmError,
  restoreVmReset
};
